const api = `https://${location.hostname}/cgi-bin/fin-info-api/api.py?mode=default`;

export default {
    authenticate() {
        const that = this;
        // Return new promise
        return new Promise(function (resolve, reject) {
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    // Parse JSON response and check for authentication success
                    if (json.result.match(/^OK/i)) {
                        // Store user data in session storage
                        that.create_session(json.department, json.name+" "+json.surname);
                        // Return success
                        resolve(true);
                    } else if(json.result.match(/^Warning/i) && json.department.match(/^student/i)){
                        //If User is a student, still creates a session. It will be filtered in Router
                        that.create_session(json.department, "");
                        resolve(true);
                    }else {
                        // Authentication was unsuccessful
                        that.destroy_session();
                        reject(false);
                    }
                })
                .catch(function () {
                    // API call was unsuccessful
                    that.destroy_session();
                    reject(false);
                })
        })
    },
    create_session(department, name) {
        let user = {
            department: department,
            fullname: name
        };
        // Create user session storage
        sessionStorage.setItem('user', JSON.stringify(user));
    },
    destroy_session() {
        // Destroy session storage
        sessionStorage.clear();
    },
    get_user() {
        // Return user object
        return JSON.parse(sessionStorage.getItem('user'));
    },
    is_Student(){ //Checks if a user is a student
        let user = this.get_user();

        if(user.department == "student"){
            return true;
        }

        return false;
    },
    is_ITS(){
        let user = this.get_user();

        if(user.department.match(/^Information Technology Services/i)){
            return true;
        }

        return false;
    }
}